export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const PHONE_DISPLAY = "0151 50778186";
export const PHONE_TEL = "tel:015150778186";
export const EMAIL = "info@terbeck-service.de";
export const WHATSAPP_URL = "https://wa.me/4915150778186";
export const SERVICES = [
  "Epoxidharzboden / Bodenbeschichtung",
  "Hausmeisterservice",
  "Gebäudereinigung",
  "Pflasterreinigung",
  "Sonstiges",
];
